export const letterSpacing = { sm: '0.1px', md: '0.2px' };
